import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import { euCountryCodes } from '../../constants/customs';
import { useEnableEuPidCustomsFields } from '../../feature-flags/hooks/use-enable-eu-pid-customs-fields';
import { useFulfillmentPlannerContext } from '../../fulfillment-planner/context';

const isEuCountry = (countryCode?: string | null): boolean => !!countryCode && euCountryCodes.includes(countryCode.toUpperCase());

export const useShouldShowEuPidFields = (): boolean => {
  const { shipFromId, shipTo, needsCustoms } = useFulfillmentPlannerContext();
  const isEnabled = useEnableEuPidCustomsFields();
  const shipFromCountryCode: string | undefined = useSelector(
    (state) => Global.selectSellerShipFromsById(state, { shipFromId })?.countryCode,
  );

  const isInternational = typeof needsCustoms === 'boolean' ? needsCustoms : needsCustoms?.needsCustoms;
  const shipToCountryCode = shipTo?.countryCode;

  return isEnabled && !!isInternational && !!shipFromCountryCode && !isEuCountry(shipFromCountryCode) && isEuCountry(shipToCountryCode);
};
